// 代理为/api封装请求
import axios from 'axios';
import qs from 'qs';
import store from '../store/index.js'
import webConfig from '../utils/global.config.js';//不需要带token的路由卸写在这个文件
// import {Base64} from 'js-base64';//base64




let requestAps = axios.create({
	//1.基础配置
	baseURL:'/aps',
	timeout: 10000,
	responseType:'json',//接口形式为json形式
	headers: {
	    'Content-Type': 'application/json'  // 设置默认请求头  application/x-www-form-urlencoded
	},
	transformRequest: [(data, headers) => {
	    
	    return qs.stringify(data);
	}]
	
	
})
requestAps.interceptors.request.use((config) => {
	let whiteList = webConfig.whiteListApi;
	let url = config.url;
	let token = store.state.user.token;


	if (whiteList.indexOf(url) === -1 && token) {

		config.headers.token = token 	// 不在白名单并且token也存在
		
		// GET 请求同时在 URL 参数中添加 token
		if (config.method === 'get') {
			config.params = {
				...config.params,
				token: token
			};
		}
	}

	//秘钥--secretId+特殊算法
	// let _secret = Base64.encode(webConfig.secretId + new Date().toString())
	// config.headers.secret = _secret
	return config;
},error =>{

	return Promise.reject(new Error(error))
})
requestAps.interceptors.response.use((res) => {
	const status = res.status || 200
	const message = res.data.msg || '未知错误'
	if (status === 401) {
		alert("你没有权限");
		// 跳转到重新登录页面
		return Promise.reject(new Error(message));
	}
	if (status !== 200) {
		
		return Promise.reject(new Error(message));
	}else{
		return res
	}
},error => {
	return Promise.reject(new Error(error))
})
export default requestAps
